import type { KnowledgeBaseEntity } from '../types';

/** Category → Tailwind color classes for badges and highlights. */
export const CATEGORY_COLORS: Record<KnowledgeBaseEntity['category'], string> = {
  amenity: 'bg-blue-100 text-blue-700',
  restaurant: 'bg-orange-100 text-orange-700',
  activity: 'bg-green-100 text-green-700',
  event: 'bg-yellow-100 text-yellow-700',
  spa_service: 'bg-pink-100 text-pink-700',
  golf: 'bg-emerald-100 text-emerald-700',
  room: 'bg-purple-100 text-purple-700',
  offer: 'bg-amber-100 text-amber-700',
  service: 'bg-cyan-100 text-cyan-700',
  attraction: 'bg-teal-100 text-teal-700',
  faq: 'bg-indigo-100 text-indigo-700',
  notice: 'bg-slate-100 text-slate-700',
  policy: 'bg-red-100 text-red-700',
};

/** Get Tailwind color classes for a category, with fallback. */
export function getCategoryColor(category: string): string {
  return CATEGORY_COLORS[category as KnowledgeBaseEntity['category']] || 'bg-surface-100 text-surface-700';
}

/** Category → Badge variant mapping for the shared Badge component. */
const CATEGORY_BADGE_VARIANTS: Record<KnowledgeBaseEntity['category'], string> = {
  amenity: 'info',
  restaurant: 'warning',
  activity: 'success',
  event: 'warning',
  spa_service: 'purple',
  golf: 'success',
  room: 'purple',
  offer: 'warning',
  service: 'info',
  attraction: 'success',
  faq: 'primary',
  notice: 'default',
  policy: 'error',
};

/** Get Badge variant for a category. */
export function getCategoryBadgeVariant(category: string): 'default' | 'primary' | 'success' | 'warning' | 'info' | 'purple' | 'error' {
  return (CATEGORY_BADGE_VARIANTS[category as KnowledgeBaseEntity['category']] || 'default') as
    'default' | 'primary' | 'success' | 'warning' | 'info' | 'purple' | 'error';
}
